import React, { useCallback } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { FilterTitle, FilterDropdown, Sort } from "@arcteryx/components-filterbar";
import { Breakpoint } from "@arcteryx/components-typography";
import { spinalCase } from "../helpers";
import { connectSortBy } from "react-instantsearch-dom";

const FilterTitleBase = styled(props => <FilterTitle {...props}/>)``;

const StyledSortBy = styled(props => <Sort {...props}/>)`
  width: 50%;
  ${Breakpoint("sm")`
    width: 40%
  `}
  ${Breakpoint("lg")`
    width: initial;
  `}
  &.activeCategory, &.activeFilter {
    max-height: 107.333rem;
    opacity: 1;
    pointer-events: auto;
    ${Breakpoint("xl")`
      max-height: 100rem;
    `}
    .arc-Filter {
      opacity: 1;
      pointer-events: auto;
    }
  }
`;

/* 
* Algolia function connectSortBy() will return the props:
* - attribute (DOM annotation)
* - items (all available facets of an attribute)
* - refine (function to update the search on user selection)
*/
const SortBy = ({
  attribute,
  items,
  refine,
  activeCategory,
  handleSetActiveFilters,
  handleSetActiveCategory
}) => {
  const { t } = useTranslation("container-search");
  const isActive = activeCategory === attribute;

  const filterTitleToggle = () => {
    handleSetActiveFilters(isActive ? null : attribute);
    handleSetActiveCategory(isActive ? null : attribute);
  };
 

  const refineFilter = useCallback((val) => {
    const currentItem = items?.find(item => item?.id.toLowerCase() === val?.id.toLowerCase());
    const value = currentItem?.value;
    const name = currentItem?.id;
    refine(value);
    handleSetActiveFilters(isActive ? null : name);
    handleSetActiveCategory(null);
  }, [items]);

  const activeFacets = items
    ?.filter(item => item.isRefined)
    ?.map(item => ({ ...item, catId: attribute}));

  return (
    <StyledSortBy className={`${isActive ? "active" : ""}`} catId={spinalCase(attribute)}>
      <FilterTitleBase
        className={"filter-category-title"}
        catId={attribute}
        label={t("Sort")} 
        isActive={isActive}
        activeFacets={activeFacets}
        handleCategoryChange={filterTitleToggle}
      />
      <FilterDropdown
        context={"sort"}
        catId={attribute}
        items={items}
        hasChildren={false}
        isActive={isActive}
        activeFacets={activeFacets}
        handleFacetClick={refineFilter}
      />
    </StyledSortBy>
  )
};

export const FilterSortBy = connectSortBy(React.memo(SortBy));